"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var client_lib_js_rx_player_1 = require("@sky-uk-ott/client-lib-js-rx-player");
var client_lib_js_player_addons_common_player_1 = require("@sky-uk-ott/client-lib-js-player-addons-common-player");
var utils = require("@sky-uk-ott/client-lib-js-player-framework-utils");
var PLAYER_ELEMENT_ID = 'ctvframework-video-browser';
var BrowserPlayer = (function (_super) {
    __extends(BrowserPlayer, _super);
    function BrowserPlayer(keySystemOptionsManager, rxPlayerConstructor, frameworkUtils) {
        var _a;
        if (rxPlayerConstructor === void 0) { rxPlayerConstructor = client_lib_js_rx_player_1.default; }
        if (frameworkUtils === void 0) { frameworkUtils = utils; }
        var _this = _super.call(this) || this;
        _this.keySystemOptionsManager = keySystemOptionsManager;
        _this.rxPlayerConstructor = rxPlayerConstructor;
        _this.frameworkUtils = frameworkUtils;
        _this.getRootElement = function () { return _this.rootElement; };
        _this.playerStateChangeHandler = function (playerState) {
            _this.playerStateHandlers[playerState]();
        };
        _this.errorHandler = function (e) {
            _this.notifyError({ code: '0000', message: e.message, isFatal: true });
        };
        _this.positionUpdateHandler = function (e) {
            _this.notifyCurrentPositionChanged(e.position);
        };
        _this.audioTrackChangeHandler = function (audioTrack) {
            _this.notifyCurrentAudioTrackChanged(_this.transformAudioTrack(audioTrack).trackId);
        };
        _this.playerStateHandlers = (_a = {},
            _a[client_lib_js_rx_player_1.PLAYER_STATES.STOPPED] = function () {
                _this.notifyStateChange(client_lib_js_player_addons_common_player_1.PlayerState.Stopped);
            },
            _a[client_lib_js_rx_player_1.PLAYER_STATES.BUFFERING] = function () {
                _this.notifyStateChange(client_lib_js_player_addons_common_player_1.PlayerState.Rebuffering);
            },
            _a[client_lib_js_rx_player_1.PLAYER_STATES.PLAYING] = function () {
                _this.notifyStateChange(client_lib_js_player_addons_common_player_1.PlayerState.Playing);
            },
            _a[client_lib_js_rx_player_1.PLAYER_STATES.SEEKING] = function () {
                _this.notifyStateChange(client_lib_js_player_addons_common_player_1.PlayerState.Paused);
            },
            _a[client_lib_js_rx_player_1.PLAYER_STATES.PAUSED] = function () {
                _this.notifyStateChange(client_lib_js_player_addons_common_player_1.PlayerState.Paused);
            },
            _a[client_lib_js_rx_player_1.PLAYER_STATES.LOADING] = function () {
                _this.notifyStateChange(client_lib_js_player_addons_common_player_1.PlayerState.Loading);
            },
            _a[client_lib_js_rx_player_1.PLAYER_STATES.ENDED] = function () {
                _this.notifyStateChange(client_lib_js_player_addons_common_player_1.PlayerState.Finished);
            },
            _a[client_lib_js_rx_player_1.PLAYER_STATES.LOADED] = function () {
                var audioTracks = _this.getAudioTracks();
                _this.notifyAvailableAudioTracksChanged(audioTracks);
                _this.setDefaultAudioTrack(audioTracks);
                _this.videoElement.playbackRate = 1.0;
                _this.notifyDurationChanged(_this.player.getVideoDuration());
            },
            _a);
        return _this;
    }
    BrowserPlayer.prototype.initialise = function () {
        return Promise.resolve();
    };
    BrowserPlayer.prototype.nativeLoad = function (nativeLoadData) {
        this.defaultAudioLanguage = nativeLoadData.defaultAudioLanguage;
        var videoHTMLContainerInfo = nativeLoadData.videoHTMLContainerInfo;
        this.createVideoElement(nativeLoadData.autoplay, videoHTMLContainerInfo);
        if (videoHTMLContainerInfo) {
            this.videoElement.style.width = '100%';
            this.videoElement.style.height = '100%';
        }
        else {
            this.setPlayoutRect(nativeLoadData.custom && nativeLoadData.custom.playoutRect);
        }
        this.player.loadVideo({
            url: nativeLoadData.cdn.url,
            transport: 'smooth',
            autoPlay: nativeLoadData.autoplay,
            keySystems: this.keySystemOptionsManager.getAllKeySystemOptions(nativeLoadData.drmConfiguration),
        });
    };
    BrowserPlayer.prototype.initiateSeek = function (seconds) {
        this.player.seekTo(seconds);
    };
    BrowserPlayer.prototype.nativeStop = function () {
        this.player.stop();
        this.removeVideoListeners();
        this.destroyVideoElement();
    };
    BrowserPlayer.prototype.nativePause = function () {
        this.player.pause();
    };
    BrowserPlayer.prototype.nativePlay = function () {
        this.player.play();
    };
    BrowserPlayer.prototype.getFullScreenPlayoutRect = function () {
        return {
            x: 0,
            y: 0,
            width: document.body.clientWidth,
            height: document.body.clientHeight,
        };
    };
    BrowserPlayer.prototype.setPlayoutRect = function (playoutRect) {
        var fullScreenRect = this.getFullScreenPlayoutRect();
        var rect = playoutRect || fullScreenRect;
        this.videoElement.style.zIndex = "" + ('zIndex' in rect ? rect.zIndex : -1000);
        this.videoElement.style.position = 'absolute';
        this.videoElement.style.left = (rect.x || fullScreenRect.x) + "px";
        this.videoElement.style.top = (rect.y || fullScreenRect.y) + "px";
        this.videoElement.style.width = (rect.width || fullScreenRect.width) + "px";
        this.videoElement.style.height = (rect.height || fullScreenRect.height) + "px";
        this.videoElement.style.backgroundColor = rect.backgroundColor;
    };
    BrowserPlayer.prototype.nativeSetAudioTrack = function (trackId) {
        var audioTrack = this.getAudioTracks().find(function (candidate) { return candidate.trackId === trackId; });
        if (audioTrack) {
            this.player.setAudioTrack(trackId);
        }
    };
    BrowserPlayer.prototype.dispose = function () {
        return Promise.resolve();
    };
    BrowserPlayer.prototype.nativeSetVolume = function (volume) {
        this.player.setVolume(volume);
    };
    BrowserPlayer.prototype.setDefaultAudioTrack = function (tracks) {
        if (this.defaultAudioLanguage) {
            var defaultAudioLanguage_1;
            if (Array.isArray(this.defaultAudioLanguage)) {
                defaultAudioLanguage_1 = this.getFirstAvailableLanguage(this.defaultAudioLanguage, tracks);
            }
            else {
                defaultAudioLanguage_1 = this.defaultAudioLanguage;
            }
            if (defaultAudioLanguage_1) {
                var audioTrack = tracks.find(function (at) { return at.language === defaultAudioLanguage_1; });
                this.defaultAudioLanguage = null;
                if (audioTrack) {
                    this.setAudioTrack(audioTrack.trackId);
                }
            }
            else if (tracks[0]) {
                this.setAudioTrack(tracks[0].trackId);
            }
        }
    };
    BrowserPlayer.prototype.getFirstAvailableLanguage = function (defaultAudioLanguages, audioTracks) {
        return defaultAudioLanguages.find(function (language) { return audioTracks.find(function (track) { return track.language === language; }) !== undefined; });
    };
    BrowserPlayer.prototype.createVideoElement = function (autoplay, videoHTMLContainerInfo) {
        if (autoplay === void 0) { autoplay = false; }
        if (this.videoElement) {
            return;
        }
        var attributes = { id: PLAYER_ELEMENT_ID };
        this.videoElement = this.frameworkUtils.createElement('video', attributes);
        this.videoElement.autoplay = autoplay;
        if (videoHTMLContainerInfo) {
            if (videoHTMLContainerInfo.videoElementClassName) {
                this.videoElement.classList.add(videoHTMLContainerInfo.videoElementClassName);
            }
            videoHTMLContainerInfo.videoHTMLContainer.appendChild(this.videoElement);
            this.rootElement = videoHTMLContainerInfo.videoHTMLContainer;
        }
        else {
            this.frameworkUtils.appendToBody(this.videoElement);
            this.rootElement = document.body;
        }
        this.player = new this.rxPlayerConstructor({
            videoElement: this.videoElement,
        });
        this.addVideoListeners();
    };
    BrowserPlayer.prototype.destroyVideoElement = function () {
        this.videoElement.parentNode.removeChild(this.videoElement);
        this.videoElement = null;
    };
    BrowserPlayer.prototype.addVideoListeners = function () {
        this.player.addEventListener('playerStateChange', this.playerStateChangeHandler);
        this.player.addEventListener('error', this.errorHandler);
        this.player.addEventListener('positionUpdate', this.positionUpdateHandler);
        this.player.addEventListener('audioTrackChange', this.audioTrackChangeHandler);
    };
    BrowserPlayer.prototype.removeVideoListeners = function () {
        this.player.removeEventListener('playerStateChange', this.playerStateChangeHandler);
        this.player.removeEventListener('error', this.errorHandler);
        this.player.removeEventListener('positionUpdate', this.positionUpdateHandler);
        this.player.removeEventListener('audioTrackChange', this.audioTrackChangeHandler);
    };
    BrowserPlayer.prototype.getAudioTracks = function () {
        var audioTracks = this.player.getAvailableAudioTracks() || [];
        return audioTracks.map(this.transformAudioTrack);
    };
    BrowserPlayer.prototype.transformAudioTrack = function (track) {
        return {
            language: track.language,
            trackId: String(track.id),
        };
    };
    return BrowserPlayer;
}(client_lib_js_player_addons_common_player_1.Player));
exports.BrowserPlayer = BrowserPlayer;
